var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "period-selection-container" }, [
    _c(
      "div",
      { staticClass: "period-selection-container__section" },
      _vm._l(_vm.getPeriods, function(p, index) {
        return _c(
          "div",
          {
            key: "period-selection" + index,
            staticClass: "period-selection-container__period",
            class: [{ active: p.active && !p.completed }],
            on: {
              click: function($event) {
                return _vm.onSelectPeriodHandler(p)
              }
            }
          },
          [
            _c(
              "span",
              { staticClass: "d-block color-gray-7 font-14 font-weight-bold" },
              [_vm._v(" " + _vm._s(p.month) + " ")]
            ),
            _c("span", { staticClass: "color-gray-7 font-14" }, [
              _vm._v(" " + _vm._s(p.year) + " ")
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }